var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "app-container",
        staticStyle: { height: "calc(100vh - 130px)", "overflow-y": "auto" },
      },
      [
        _c(
          "el-form",
          {
            ref: "form",
            attrs: {
              model: _vm.queryForm,
              size: "small",
              "label-position": _vm.$i18n.locale !== "zh" ? "top" : "right",
              "label-width": _vm.$i18n.locale !== "zh" ? "auto" : "160px",
            },
          },
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "template",
                          { slot: "label" },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "operationCenter.PleaseSelect"
                                  ),
                                },
                                model: {
                                  value: _vm.queryForm.numberField,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryForm, "numberField", $$v)
                                  },
                                  expression: "queryForm.numberField",
                                },
                              },
                              _vm._l(_vm.ORDER_TYPE, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm
                              .$t("newOrder.PreciseSearch")
                              .replace("200", 20000 + ""),
                            rows: 4,
                            type: "textarea",
                          },
                          model: {
                            value: _vm.numberList,
                            callback: function ($$v) {
                              _vm.numberList = $$v
                            },
                            expression: "numberList",
                          },
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _c("el-col", { attrs: { span: 24 } }, [
                  _c(
                    "div",
                    { staticClass: "grid-content bg-purple" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("trajectory.TransitTime") } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "default-time": ["00:00:00", "23:59:59"],
                              "end-placeholder": _vm.$t(
                                "operationCenter.endDate"
                              ),
                              "picker-options": _vm.dateLimit,
                              "range-separator": _vm.$t("operationCenter.to"),
                              "start-placeholder": _vm.$t(
                                "operationCenter.startDate"
                              ),
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            model: {
                              value: _vm.queryDate,
                              callback: function ($$v) {
                                _vm.queryDate = $$v
                              },
                              expression: "queryDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "template",
                          { slot: "label" },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "operationCenter.PleaseSelect"
                                  ),
                                },
                                model: {
                                  value: _vm.queryForm.customerIdField,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm,
                                      "customerIdField",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.customerIdField",
                                },
                              },
                              _vm._l(_vm.CUSTOMER_TYPE, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c("el-input", {
                          attrs: { placeholder: _vm.$t("模糊匹配") },
                          model: {
                            value: _vm.queryForm.customerName,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "customerName", $$v)
                            },
                            expression: "queryForm.customerName",
                          },
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("vehicle.modelLabel") } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "operationCenter.PleaseSelect"
                              ),
                              clearable: "",
                              filterable: "",
                            },
                            model: {
                              value: _vm.queryForm.vehicleType,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "vehicleType", $$v)
                              },
                              expression: "queryForm.vehicleType",
                            },
                          },
                          _vm._l(_vm.modelList, function (item) {
                            return _c("el-option", {
                              key: item.dictValue,
                              attrs: {
                                label: item.dictLabel,
                                value: item.dictValue,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("basicData.UnloadingType") } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "operationCenter.PleaseSelect"
                              ),
                              clearable: "",
                              filterable: "",
                            },
                            model: {
                              value: _vm.queryForm.loadingType,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "loadingType", $$v)
                              },
                              expression: "queryForm.loadingType",
                            },
                          },
                          _vm._l(_vm.locationType, function (item) {
                            return _c("el-option", {
                              key: item.dictValue,
                              attrs: {
                                label: item.dictLabel,
                                value: item.dictValue,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("basicData.PaymentMethod") } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "operationCenter.PleaseSelect"
                              ),
                              clearable: "",
                              filterable: "",
                            },
                            model: {
                              value: _vm.queryForm.paymentMethod,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "paymentMethod", $$v)
                              },
                              expression: "queryForm.paymentMethod",
                            },
                          },
                          _vm._l(_vm.paymentMethod, function (item) {
                            return _c("el-option", {
                              key: item.dictValue,
                              attrs: {
                                label: item.dictLabel,
                                value: item.dictValue,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "receivablePayable.ReconciliationStatus"
                          ),
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "operationCenter.PleaseSelect"
                              ),
                              clearable: "",
                              filterable: "",
                            },
                            model: {
                              value: _vm.queryForm.isGenBill,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "isGenBill", $$v)
                              },
                              expression: "queryForm.isGenBill",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: {
                                label: _vm.$t("GlobalSetObj.yes"),
                                value: 1,
                              },
                            }),
                            _c("el-option", {
                              attrs: {
                                label: _vm.$t("GlobalSetObj.No"),
                                value: 0,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("basicData.VerificationStatus"),
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "operationCenter.PleaseSelect"
                              ),
                              clearable: "",
                              filterable: "",
                            },
                            model: {
                              value: _vm.queryForm.isAccept,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "isAccept", $$v)
                              },
                              expression: "queryForm.isAccept",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: {
                                label: _vm.$t("GlobalSetObj.yes"),
                                value: 1,
                              },
                            }),
                            _c("el-option", {
                              attrs: {
                                label: _vm.$t("GlobalSetObj.No"),
                                value: 0,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.selectKey === 1
                  ? _c("el-col", { attrs: { span: 24 } }, [
                      _c(
                        "div",
                        { staticClass: "grid-content bg-purple" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("basicData.BatchNo"),
                                prop: "billBatchNumber",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: _vm.isReadOnly },
                                model: {
                                  value: _vm.queryForm.billBatchNumber,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm,
                                      "billBatchNumber",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.billBatchNumber",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm.selectKey === 2
                  ? _c("el-col", { attrs: { span: 24 } }, [
                      _c(
                        "div",
                        { staticClass: "grid-content bg-purple" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("basicData.ReceiptNumber"),
                                prop: "receiptNumber",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: _vm.isReadOnly },
                                model: {
                                  value: _vm.queryForm.receiptNumber,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm,
                                      "receiptNumber",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.receiptNumber",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticStyle: {
          "text-align": "center",
          "border-top": "1px solid #ccc",
          "padding-top": "10px",
        },
      },
      [
        _c(
          "el-button",
          {
            attrs: { size: "small", type: "primary" },
            on: { click: _vm.searchForm },
          },
          [_vm._v(_vm._s(_vm.$t("basicData.Search")))]
        ),
        _c(
          "el-button",
          {
            attrs: { size: "small", type: "success" },
            on: { click: _vm.onReset },
          },
          [_vm._v(_vm._s(_vm.$t("basicData.reset")))]
        ),
        _c(
          "el-button",
          { attrs: { size: "small" }, on: { click: _vm.onClose } },
          [_vm._v(_vm._s(_vm.$t("basicData.Cancel")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }